import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _process$env$NEXT_PUB;
import _regeneratorRuntime from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getIsOnpremise } from ".";
import servicesUtils from "./servicesUtils";
var axios = require("axios");
var DCMIO_BASE_URL = "http://127.0.0.1:7000";
var PLATFORM_API_URL = "".concat(process.env.NEXT_PUBLIC_API_URL).concat(((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_API_URL) === null || _process$env$NEXT_PUB === void 0 ? void 0 : _process$env$NEXT_PUB.charAt(process.env.NEXT_PUBLIC_API_URL.length - 1)) === "/" ? "" : "/");

// putting the base config in code only
var PLATFORM_DCMIO_JSON_TEMPLATE = JSON.stringify({
  version: 1,
  api: {
    base_url: "",
    token: "",
    user: "dcmio_dev",
    source: "dcmio_dev",
    timeout: 180,
    sitename: "",
    num_threads: 5
  },
  sync: {
    enabled: true,
    frequency: 900,
    server: "https://dcsm.qure.ai/",
    token: "0a68ac0ac6d54ff6fa6780437675c83265b6b267",
    timeout: 30,
    api: {
      path: "config/sync/"
    }
  },
  update: {
    enabled: true,
    type: "auto",
    confirmation: true,
    flavour: "standard",
    version: null
  },
  system: {
    groups: {
      series: ["CT", "CR", "DX", "DR"],
      instance: []
    },
    stability: {
      type: "series",
      check_delay: 16,
      process_delay: 15
    }
  },
  filter: {
    query: "True",
    enabled: false
  },
  upload: {
    api: {
      path: "studies"
    },
    batch_size: 32,
    compression: {
      enabled: true,
      options: "+eb"
    },
    anonymization: {
      enabled: false,
      fields: ["PatientID", "PatientName", "InstitutionName", "InstitutionAddress", "ReferringPhysicianName", "OperatorsName", "PatientBirthDate", "StationName", "AdditionalPatientHistory", "PatientComments", "PlateID", "AdmissionID", "ConfidentialityOnPatientDataDescr"],
      algorithms: {
        "default": {
          type: "random"
        },
        PatientID: {
          type: "hash",
          fields: ["PatientID", "StudyID"]
        }
      }
    }
  },
  compute: {
    enabled: false,
    api: {
      path: "compute",
      parameters: {
        recompute: "True"
      }
    }
  },
  results: {
    enabled: true,
    api: {
      path: "results"
    },
    cases: {
      success: [{
        status: 200,
        results: {
          success: true
        }
      }, {
        status: 400,
        results: {
          success: false
        }
      }, {
        status: 500,
        results: {
          success: false
        }
      }],
      try_again: [{
        status: 200,
        results: {
          success: false
        }
      }, {
        status: 202
      }, {
        status: 409
      }]
    }
  },
  publishers: [{
    type: "logging",
    common: {
      enabled: true
    }
  }],
  cleanup: {
    enabled: true,
    frequency: 600,
    all_series: {
      delay: 21600,
      enabled: true
    },
    processed_series: {
      delay: 3600,
      enabled: true,
      creation_delay: 3600
    },
    processing_tasks: {
      delay: 0,
      enabled: true
    },
    registration_tasks: {
      delay: 0,
      enabled: true
    }
  }
});
function populatePlatformJson(platformJson, values) {
  platformJson.api = _objectSpread(_objectSpread({}, platformJson.api), values);
}
function postDcmioConfig(_x) {
  return _postDcmioConfig.apply(this, arguments);
} // no error checking, im not sure what the contracts of the API are when it succeeds, please do any checking you want
function _postDcmioConfig() {
  _postDcmioConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.post("".concat(DCMIO_BASE_URL, "/config/"), config);
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _postDcmioConfig.apply(this, arguments);
}
function transformedUserDataToDcmioApi(userData) {
  var isOnpremise = getIsOnpremise();
  return {
    token: userData.token,
    user: userData.username,
    source: userData.upload_sources[0].uuid,
    base_url: isOnpremise ? "http://host.docker.internal:2001/" : PLATFORM_API_URL
  };
}
function getUserData() {
  return _getUserData.apply(this, arguments);
}
function _getUserData() {
  _getUserData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return servicesUtils.getService("/profile/");
          case 2:
            result = _context2.sent;
            return _context2.abrupt("return", result);
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getUserData.apply(this, arguments);
}
function configureDcmio() {
  return _configureDcmio.apply(this, arguments);
}
function _configureDcmio() {
  _configureDcmio = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var platformJson, userData, api;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            platformJson = JSON.parse(PLATFORM_DCMIO_JSON_TEMPLATE); // please use whatever funciton you use for getUserData
            _context3.next = 3;
            return getUserData();
          case 3:
            userData = _context3.sent;
            api = transformedUserDataToDcmioApi(userData);
            populatePlatformJson(platformJson, api);
            _context3.next = 8;
            return postDcmioConfig(platformJson);
          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _configureDcmio.apply(this, arguments);
}
export default configureDcmio;